/**
 * Created by Ivan on 21.08.2025
 */

cleverapps.override(cleverapps.EVENTS, {
    EARN: {
        WEEKLY_GOALS: "weekly_goals"
    },

    WEEKLY_GOALS_OPEN: "wg_open",
    WEEKLY_GOALS_AVAILABLE: "wg_available",
    WEEKLY_GOALS_FINISHED: "wg_finished",
    WEEKLY_GOALS_UNCLAIMED: "wg_unclaimed",

    WEEKLY_GOALS_DONE: "wg_done",

    WEEKLY_GOALS_PLAYERS: "wg_players",
    WEEKLY_GOALS_COMPLETE_GOAL: "wg_reach"
});
